<template>
  <div>
    <div>
      <v-row id="chatRow">
        <span class="author-name">{{
          message.userView.firstName + ' ' + message.userView.lastName
        }}</span>
        <span class="delete-arrow">
          <i
            v-if="message.isCurrentUser"
            class="material-icons"
            @click="removeMessage(message.id)"
            >close</i
          >
        </span>
      </v-row>
    </div>
    <div>

        <a
          v-for="fileItem in message.files"
          :href="fileItem.file"
          :key="fileItem.id"
          target="_blank"
          :download="fileItem.name"
          >
          <span> {{ fileItem.name }}</span> <i class="material-icons">cloud_download</i></a
        >

      <div v-html="message.text"></div>
      <v-row id="readStatus">
        <i class="material-icons" v-if="message.isRead">done</i>
      </v-row>
    </div>
  </div>
</template>

<script>
import messageEventEnum from '@/enums/messageEventEnum';

export default {
  name: 'Message',
  props: {
    message: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    removeMessage(id) {
      this.$emit('messageEvent', {
        type: messageEventEnum.REMOVE_MESSAGE,
        data: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.author-name {
  font-size: 18px;
  font-weight: bold;
}

#chatRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
}

#readStatus {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0;
}

</style>
